import { fetchFromOldApi } from '~/services/Http';

import { IFormInput } from '../useEmergencyContact';

export type EmpEmeContactType = {
  fEmpEmeEmail: string;
  fEmpEmeName: string;
  fEmpEmePhone: string;
};

export const deleteEmpEmeContactData = async (iEmpId: number) => {
  return await fetchFromOldApi('/json/employee/' + iEmpId + '/eme', {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
  }).then((r) => r.json());
};

export const putEmeContactData = async (json: IFormInput, iEmpId: number) => {
  return await fetchFromOldApi('/form/employee/' + iEmpId + '/eme', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(json),
  }).then((r) => r.json());
};
